import { plainToClass } from 'class-transformer'
import { validate } from 'class-validator'
import { GetEventStatDTO } from '../../dto/events'
import { store } from '../../store'

export const getEventStat = async ( id: number | null ) => {

    let body, response

    try {

        response = await fetch( `${ process.env.REACT_APP_API_ORIGIN }/1.0.0/cms/events/${ id }/stats`, {
            headers: {
                'Authorization': 'Bearer ' + store.getState().session.token,
                'Content-Type': 'application/json'
            },
            method: 'get'
        } )

    } catch ( exception ) {

        store.dispatch( { type: 'GET_EVENT_STAT_TIMEOUT' } )
        return

    }

    if ( response.status === 401 ) {

        store.dispatch( { type: 'GET_EVENT_STAT_UNAUTHORIZED' } )
        return

    }

    if ( response.status !== 200 ) {

        store.dispatch( { type: 'GET_EVENT_STAT_UNEXPECTEDRESPONSE' } )
        return

    }

    try {

        body = plainToClass( GetEventStatDTO, JSON.parse( await response.text() ) )

    } catch ( exception ) {

        store.dispatch( { type: 'GET_EVENT_STAT_INVALIDJSON' } )
        return

    }

    if ( ( await validate( body ) ).length > 0 ) {

        store.dispatch( { type: 'GET_EVENT_STAT_INVALIDRESPONSE' } )
        return

    }

    store.dispatch( { type: 'GET_EVENT_STAT_OK', eventStat: body } )

}
